/**
 * LetterPreviewCard
 * -----------------
 * Read-only view of the generated request letter, shown while the request
 * is still a draft.
 */
const LetterPreviewCard = ({ letterContent }) => (
  <section className="mb-4 rounded-lg bg-ground px-6 py-5" data-testid="letter-preview">
    <h2 className="font-heading text-[19px] font-semibold tracking-[-0.02em] text-ink">Your request letter</h2>
    <p className="mt-2 text-[15px] leading-[1.6] text-ink-70 max-w-[60ch]">
      This is what we will send for you. It covers everything the law requires, including what
      they may and may not black out.
    </p>
    <div className="mt-4 max-h-[420px] overflow-y-auto rounded-lg bg-surface px-5 py-4">
      <pre className="whitespace-pre-wrap font-mono text-[13px] leading-[1.7] text-ink-70">
        {letterContent}
      </pre>
    </div>
  </section>
);

export default LetterPreviewCard;
